import {
  getLocalStorageRole,
  setLocalStorageRole,
} from "api/dropsLocalStorage";
import { UserRole } from "shared/types/roles";
import { create } from "zustand";

const getInitialRole = () => {
  const role = getLocalStorageRole();
  if (role === null || !Object.values(UserRole).includes(role)) {
    // Set role to vaktleder just temporarily until selectRole.tsx updates your role
    const defaultRole =
      role === UserRole.trafikkplanlegger
        ? UserRole.trafikkplanlegger60
        : UserRole.vaktleder;
    setLocalStorageRole(defaultRole);
    return defaultRole;
  }
  return role;
};

type State = {
  role: UserRole;
};

type Action = {
  setRole: (newRole: State["role"]) => void;
  isVaktleder: () => boolean;
  isTrafikkplanlegger: () => boolean;
  isTrafikkplanleggerOrOKS: () => boolean;
  isLokleder: () => boolean;
  isDriftledningen: () => boolean;
  isVaktlederOrDriftledningen: () => boolean;
  isVaktlederOrDriftledningenOrTrafikkplanlegger: () => boolean;
};

export const useDropsRole = create<State & Action>((set, get) => ({
  role: getInitialRole(),
  setRole: (newRole) => {
    set(() => {
      setLocalStorageRole(newRole);
      return { role: newRole };
    });
  },
  isVaktleder: () => {
    const userRole = get().role;
    return (
      userRole === UserRole.vaktleder || userRole === UserRole.transportleder
    );
  },
  isTrafikkplanlegger: () =>
    [
      UserRole.trafikkplanlegger,
      UserRole.trafikkplanlegger60,
      UserRole.trafikkplanlegger63,
    ].includes(get().role),
  isTrafikkplanleggerOrOKS: () =>
    [
      UserRole.trafikkplanlegger,
      UserRole.trafikkplanlegger60,
      UserRole.trafikkplanlegger63,
      UserRole.oks,
    ].includes(get().role),
  isLokleder: () =>
    [UserRole.lokleder1, UserRole.lokleder2].includes(get().role),
  isDriftledningen: () => get().role === UserRole.driftledningen,
  isVaktlederOrDriftledningen: () =>
    get().isVaktleder() || get().isDriftledningen(),
  isVaktlederOrDriftledningenOrTrafikkplanlegger: () =>
    get().isVaktleder() ||
    get().isDriftledningen() ||
    get().isTrafikkplanlegger(),
}));
